var _desc, _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 150,
    viewBox: "0 0 242 150",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Minh h\u1ECDa b\u1EA3o m\u1EADt k\xFD s\u1ED1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "M\u1ED9t b\xE0n tay c\u1EA7m \u0111i\u1EC7n tho\u1EA1i v\u1EDBi bi\u1EC3u t\u01B0\u1EE3ng d\u1EA5u t\xEDch xanh l\xE1 trong khi\xEAn b\u1EA3o m\u1EADt, k\xE8m \u1ED5 kh\xF3a, phong c\xE1ch ph\u1EB3ng hai t\xF4ng xanh d\u01B0\u01A1ng.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "phoneClipSmall"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 12,
    width: 14,
    height: 24,
    rx: 1.6
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 242,
    height: 150,
    fill: "#eff1fd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.75,0) scale(0.3125)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 340,
    cy: 430,
    rx: 220,
    ry: 24,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 300 Q160 340 190 400 Q220 440 280 440 L400 440 Q420 400 400 360 Q380 320 340 300 Z",
    fill: "#bfdbfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 340 Q210 320 205 290 Q200 260 220 240 Q240 220 270 225 L280 260 Q260 265 255 285 Q250 305 265 325 Z",
    fill: "#93c5fd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 120,
    width: 140,
    height: 240,
    rx: 16,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 140,
    width: 124,
    height: 190,
    rx: 4,
    fill: "#eff6ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 342,
    r: 8,
    fill: "#93c5fd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 155,
    width: 100,
    height: 10,
    rx: 2,
    fill: "#93c5fd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 175,
    width: 70,
    height: 8,
    rx: 2,
    fill: "#bfdbfe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 195,
    width: 90,
    height: 8,
    rx: 2,
    fill: "#bfdbfe"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 255,
    r: 42,
    fill: "#22c55e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 255 L334 269 L362 240",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 150,
    width: 70,
    height: 55,
    rx: 8,
    fill: "#1e40af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485 150 L485 130 Q485 108 505 108 Q525 108 525 130 L525 150",
    fill: "none",
    stroke: "#1e40af",
    strokeWidth: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505,
    cy: 175,
    r: 7,
    fill: "#eff6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501,
    y: 178,
    width: 8,
    height: 14,
    rx: 2,
    fill: "#eff6ff"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#60a5fa",
    strokeWidth: 6,
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420 150 Q440 150 450 165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 175 Q450 175 465 195"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#1e40af"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 130,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 105,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 260,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 300,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 220,
    r: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.948253728759befa2791c3c8ae104d30.svg";
export { ForwardRef as ReactComponent };